import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useEffect, useMemo, useRef, useState } from 'react';
import { View } from 'react-native';
import { TextInput } from 'react-native-paper';
export const OneTimePasswordInput = ({ mode = 'outlined', keyboardType = 'number-pad', length = 6, value = '', ...restProps }) => {
    const [currentIndex, setCurrentIndex] = useState();
    const inputRefs = useRef([]);
    const characters = useMemo(() => {
        const theCharacters = new Array(length).fill('');
        Array.from(value?.slice(0, length) || '').forEach((v, i) => {
            theCharacters[i] = v;
        });
        return theCharacters;
    }, [value, length]);
    // Initialize our OTP characters state from the incoming value, if any.
    useEffect(() => {
        const firstEmpty = characters.findIndex((char) => char === '');
        setCurrentIndex(firstEmpty === -1 ? length - 1 : firstEmpty);
    }, [value, length]);
    // Autofocus the input corresponding to currentIndex.
    useEffect(() => {
        if (currentIndex !== undefined && inputRefs.current.length > 0) {
            inputRefs.current[currentIndex]?.focus();
        }
    }, [currentIndex, inputRefs]);
    // Called when a user types or pastes into an input.
    const onDigitTextChanged = (text, index) => {
        let updatedDigits;
        if (text.length > 1) {
            // Paste event detected within the input.
            updatedDigits = Array.from(text).slice(0, length);
        }
        else {
            // Single-digit entry.
            updatedDigits = [...characters];
            updatedDigits[index] = text;
        }
        if (restProps.onChangeText) {
            restProps.onChangeText(updatedDigits.join(''));
        }
    };
    const onDigitKeyPress = (event) => {
        if (event.nativeEvent.key === 'Backspace' && currentIndex !== undefined) {
            const updatedDigits = [...characters];
            if (currentIndex > 0 && updatedDigits[currentIndex] === '') {
                // Backspace key pressed on empty input - just move to previous input
                setCurrentIndex(currentIndex - 1);
            }
            else {
                // Backspace key pressed on input with value - remove value and then move to previous input
                updatedDigits[currentIndex] = '';
                if (restProps.onChangeText) {
                    restProps.onChangeText(updatedDigits.join(''));
                }
            }
        }
    };
    // Save input references
    const onSetReference = (inputElement, index) => {
        inputRefs.current[index] = inputElement;
    };
    return (_jsx(View, { style: { flexDirection: 'row' }, children: characters.map((_digit, index) => (_createElement(TextInput, { ...restProps, ref: (inputElement) => onSetReference(inputElement, index), key: index, 
            // Allow the first input to accept the entire OTP length for paste events
            maxLength: index === 0 ? length : 1, value: characters[index], onChangeText: (text) => onDigitTextChanged(text, index), onKeyPress: onDigitKeyPress, keyboardType: keyboardType, style: restProps.style || { width: 40, marginHorizontal: 5 }, mode: mode }))) }));
};
